import { styled } from "styled-components";

import { MQ } from "style/mediaQueries";

export const OpenPositions = styled.div`
    display: flex;
    flex-flow: row wrap;
    row-gap: 1.75rem;

    ${MQ.FROM_M} {
        row-gap: 2.625rem;
    }

    ${MQ.FROM_XL} {
        row-gap: 3.5rem;
    }
`;
